import React, { FC, CSSProperties, ReactNode } from "react";
import { grid as gridPageToken } from "../tokens";

interface ContentWrapperProps {
  children: ReactNode;
  Tag: "div" | "section";
  className?: string;
  style?: CSSProperties;
}

const ContentWrapper: FC<ContentWrapperProps> = ({
  children,
  Tag = "div",
  className,
  ...rest
}) => {
  const GridToken = gridPageToken();

  return (
    <Tag className={GridToken.contentWrapper + " " + className} {...rest}>
      {children}
    </Tag>
  );
};

export default ContentWrapper;
